import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { Button } from '@wbk/ui';
import useSso from '@/src/hook/useSso';

const LoginButton = () => {
  const { t } = useTranslation();
  const { loading, callbackUri, redirectToSso } = useSso();

  return (
    <Button
      theme='primary'
      shape='outlined'
      className='w-full !py-1 text-xs md:!px-2.5 xl:text-base ltr:lg:text-sm'
      loading={loading}
      disabled={!callbackUri}
      onClick={redirectToSso}
      role='menuitem'
      data-testid='login-profile'
      data-location='header'
    >
      <p className='hidden sm:block'>{t('common:auth.login_signup')}</p>
      <div className='block shrink-0 rounded-full md:hidden'>
        <Image
          className='shrink-0'
          src='/icons/profile/user-p.svg'
          width={20}
          height={20}
          alt='user icon'
        />
      </div>
    </Button>
  );
};

export default LoginButton;
